import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/basic/bscRole',
    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    updateById(f){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: f
        });
    },
    insert(f){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: f
        });
    },
    getAllUsersByRoleidPage(q){
        return http({
            url: this.baseurl+'/getAllUsersByRoleidPage',
            method: 'post',
            params: q
        });
    },
    getAllRoleByUsercode(q){
        return http({
            url: this.baseurl+'/getAllRoleByUsercode',
            method: 'post',
            params: q
        });
    },
    bindRoleres(p){
        return http({
            url: this.baseurl+'/bindRoleres',
            method: 'post',
            params: p
        });
    },
    bindRoleuser(p){
        return http({
            url: this.baseurl+'/bindRoleuser',
            method: 'post',
            params: p
        });
    },
    getAllRoles(){
        return http({
            url: this.baseurl+'/getAllRoles',
            method: 'post'
        });
    },
}
